module.exports = __webpack_public_path__ + "img/flexsale_hifi_1.54e69498.png";